




























































































































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase';
import { State, Action } from 'vuex-class';

import { GrowthCycleTemplate, Harvest, Raft } from '@/models/growth-cycle-template';

@Component
export default class GrowthCycleTemplateComponent extends Vue {
    @State('raftTypes') private raftTypesState: any;
    @Action('getRaftTypes') private getRaftTypesAction: any;

    private templatesRef = firebase.firestore().collection('growthCycleTemplates');

    private currentTemplate: GrowthCycleTemplate = {
        name: '',
        cellCount: 0,
        daysInGermination: 0,
        daysInPropagation: 0,
        daysInFinishedSpacing: 0,
        raftTypeFinishedSpacing: { cellSpacing: 0 },
        harvestType: Harvest.Once,
    };

    private isEditing = false;
    private editVals: any = {};

    private harvestTypes = [
        {
            text: 'Once',
            value: Harvest.Once,
        },
        {
            text: 'Multiple',
            value: Harvest.Many,
        },
    ];

    private raftTypes: Array<{text: string, value: number}> = [];

    private created(): void {
        this.templatesRef.doc(this.$route.params.id).get().then(
            (doc: any) => {
                this.currentTemplate = doc.data();
                this.currentTemplate.id = doc.id;
                this.editVals = this.currentTemplate;
            },
        );

        if (this.raftTypesState.length === 0) {
            this.getRaftTypesAction().then((complete: any) => {
                this.raftTypesState.map((raft: Raft) => {
                    this.raftTypes.push({
                        text: raft.cellSpacing.toString(),
                        value: raft.cellSpacing,
                    });
                });
                this.raftTypes.sort((leftSide, rightSide): number => {
                    if (leftSide.value < rightSide.value) { return -1; }
                    if (leftSide.value > rightSide.value) { return 1; }
                    return 0;
                });
            });
        } else {
            this.raftTypesState.map((raft: Raft) => {
                this.raftTypes.push({
                    text: raft.cellSpacing.toString(),
                    value: raft.cellSpacing,
                });
            });
            this.raftTypes.sort((leftSide, rightSide): number => {
                if (leftSide.value < rightSide.value) { return -1; }
                if (leftSide.value > rightSide.value) { return 1; }
                return 0;
            });
         }
     }

    private navigateBack(): void {
        this.$router.replace('/growth_cycles/templates');
    }

    private onEdit(): void {
        this.isEditing = true;
    }

    private onDelete(): void {
        this.templatesRef.doc(this.currentTemplate.id).delete()
            .then((res: any) => {
                alert('Successfully deleted');
                this.navigateBack();
            })
            .catch((err: any) => {
                alert('Could not delete template. Reason: ' + err.message);
            });
    }

    private onSave(): void {
        this.templatesRef.doc(this.currentTemplate!!.id).update(this.editVals)
             .then((res: any) => {
                alert('Successfully updated');
                this.isEditing = false;
            })
            .catch((err: any) => {
                alert('Could not update template. Reason: ' + err.message);
            });
    }

    private updateExpectedAndRemainder(): void {
        if (this.editVals.cellCount) {
            const highDensityRafts =
                this.calculateRaftsAndRemainder(
                    this.editVals.cellCount!!,
                    this.editVals.raftTypeHighDensity);
            this.editVals.expectedHighDensityRafts = highDensityRafts.rafts;
            this.editVals.expectedHighDensityCellsRemaining = highDensityRafts.remainder;
        }
        if (this.editVals.raftTypeFinishedSpacing > 0 && this.editVals.cellCount) {
            const finishedSpacingRafts =
                this.calculateRaftsAndRemainder(
                    this.editVals.cellCount!!,
                    this.editVals.raftTypeFinishedSpacing);
            this.editVals.expectedFinishedSpacingRafts =
                finishedSpacingRafts.rafts;
            this.editVals.expectedFinishedSpacingCellsRemaining =
                finishedSpacingRafts.remainder;
        }
    }

    private calculateRaftsAndRemainder(cellCount: number, raftType: number):
        {rafts: number, remainder: number} {
            const rafts = Math.floor(cellCount / raftType);
            const remainder = cellCount % raftType;

            return {rafts, remainder};
    }
}
